import React from "react";
import { apiGetPengaturan, apiUpdatePengaturan, formatApiErrorDetail } from "@/lib/api";

// Addendum 5 (A5-A): business identity for the A4 invoice, VAT rate for institution notas, QRIS account.
const FIELDS = ["alamat_usaha", "kontak_usaha", "npwp_usaha", "penanda_tangan_nama", "penanda_tangan_jabatan", "ppn_tarif_persen", "ppn_mode", "qris_rekening_id"];
const inputCls = "mt-1 w-full rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 focus:border-amber-500 focus:outline-none";
const labelCls = "text-[13px] font-semibold text-slate-200";

export default function UsahaInvoicePanel() {
  const [form, setForm] = React.useState(null);
  const [rekening, setRekening] = React.useState([]);
  const [msg, setMsg] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const isi = (c) => {
    const f = {};
    FIELDS.forEach((k) => { f[k] = c[k] ?? ""; });
    setForm(f);
    setRekening((c.rekening || []).filter((r) => r.is_active !== false));
  };
  React.useEffect(() => { apiGetPengaturan().then(isi).catch(() => {}); }, []);
  const simpan = async (e) => {
    e.preventDefault();
    setMsg(null); setSaving(true);
    try {
      const c = await apiUpdatePengaturan({
        alamat_usaha: form.alamat_usaha, kontak_usaha: form.kontak_usaha, npwp_usaha: form.npwp_usaha || "",
        penanda_tangan_nama: form.penanda_tangan_nama, penanda_tangan_jabatan: form.penanda_tangan_jabatan,
        ppn_tarif_persen: Number(form.ppn_tarif_persen) || 0, ppn_mode: form.ppn_mode || "EKSKLUSIF",
        qris_rekening_id: form.qris_rekening_id || "",
      });
      isi(c);
      setMsg({ ok: true, text: "Identitas usaha & PPN disimpan." });
    } catch (err) {
      setMsg({ ok: false, text: formatApiErrorDetail(err.response?.data?.detail) || err.message });
    } finally { setSaving(false); }
  };
  if (!form) return null;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <form onSubmit={simpan} data-testid="usaha-panel" className="rounded-xl border border-slate-800 bg-slate-900/60 p-5 space-y-3">
      <h2 className="text-[15px] font-bold text-soq-biru-tua">Identitas usaha, invoice & PPN</h2>
      <div className="grid gap-3 md:grid-cols-2">
        <div className="md:col-span-2"><label className={labelCls}>Alamat usaha (kop invoice)</label>
          <textarea data-testid="usaha-alamat" rows={2} value={form.alamat_usaha} onChange={set("alamat_usaha")} className={inputCls} /></div>
        <div><label className={labelCls}>Kontak (telepon / email usaha)</label>
          <input data-testid="usaha-kontak" value={form.kontak_usaha} onChange={set("kontak_usaha")} className={inputCls} /></div>
        <div><label className={labelCls}>NPWP usaha (opsional)</label>
          <input data-testid="usaha-npwp" value={form.npwp_usaha} onChange={set("npwp_usaha")} className={`${inputCls} font-mono`} /></div>
        <div><label className={labelCls}>Penanda tangan invoice — nama</label>
          <input data-testid="usaha-ttd-nama" value={form.penanda_tangan_nama} onChange={set("penanda_tangan_nama")} className={inputCls} /></div>
        <div><label className={labelCls}>Penanda tangan — jabatan</label>
          <input data-testid="usaha-ttd-jabatan" value={form.penanda_tangan_jabatan} onChange={set("penanda_tangan_jabatan")} className={inputCls} /></div>
        <div><label className={labelCls}>Tarif PPN nota instansi (%)</label>
          <input data-testid="usaha-ppn-tarif" type="number" min="0" max="100" step="0.01" value={form.ppn_tarif_persen} onChange={set("ppn_tarif_persen")} className={`${inputCls} font-mono`} /></div>
        <div><label className={labelCls}>Cara hitung PPN</label>
          <select data-testid="usaha-ppn-mode" value={form.ppn_mode} onChange={set("ppn_mode")} className={inputCls}>
            <option value="EKSKLUSIF">Eksklusif — PPN ditambahkan di atas harga</option>
            <option value="INKLUSIF">Inklusif — harga sudah termasuk PPN</option>
          </select></div>
        <div className="md:col-span-2"><label className={labelCls}>Rekening penampung QRIS</label>
          <select data-testid="usaha-qris" value={form.qris_rekening_id} onChange={set("qris_rekening_id")} className={inputCls}>
            <option value="">— belum dipilih —</option>
            {rekening.map((r) => <option key={r.id} value={r.id}>{r.bank} {r.nomor} a.n. {r.atas_nama}</option>)}
          </select></div>
      </div>
      <p className="text-xs text-slate-500">PPN hanya untuk nota pelanggan Instansi dan dikunci di nota saat terbit; perubahan tarif tidak mengubah nota lama. Tarif default 11% adalah [ASUMSI] — <b>konfirmasikan ke konsultan pajak</b>. Faktur pajak resmi (e-Faktur DJP) dibuat di luar aplikasi.</p>
      <div className="flex items-center gap-3">
        <button data-testid="usaha-simpan" type="submit" disabled={saving} className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-amber-400 disabled:opacity-60">Simpan identitas & PPN</button>
        {msg && <span className={`text-xs ${msg.ok ? "text-emerald-300" : "text-red-300"}`}>{msg.text}</span>}
      </div>
    </form>
  );
}
